import * as Sentry from '@sentry/browser';
import { VERSION } from '@/version.ts';
import { useSessionStore } from '@/stores/useSessionStore';

function initSentry(consentCats: string[]) {
  if (import.meta.env.MODE === 'production') {
    if (consentCats.includes('performance')) {
      Sentry.init({
        release: VERSION,
        dsn: 'https://8c9a1508929e4d9a847e94201f4bfde0@logs.services.swissenergyplanning.ch/6',
        environment: 'production'
      });
    }
    else {
      console.log('Sentry disabled: no performance consent');
    }
  }
  else {
    Sentry.init({
      release: VERSION,
      dsn: 'https://8c9a1508929e4d9a847e94201f4bfde0@logs.services.swissenergyplanning.ch/6',
      environment: 'development'
    });
  }
}

// @ts-expect-error CookieScript is not a module
if (typeof window !== 'undefined' && window.CookieScript?.instance) {
  // @ts-expect-error CookieScript is not a module
  const cs = window.CookieScript.instance;
  const setAccepted = useSessionStore.getState().setAcceptedCookieCategories;

  const initialCats = cs.currentState().categories;
  setAccepted(initialCats);
  initSentry(initialCats);

  cs.onAcceptAll = () => {
    const all = cs.categories(); // returns full list
    setAccepted(all);
    initSentry(all);
  };
  cs.onAccept = (detail: { categories: string[] }) => {
    setAccepted(detail.categories);
    initSentry(detail.categories);
  };
  cs.onReject = () => {
    setAccepted([]);
    Sentry.close().catch(console.error);
  };
}
